(() => {
  const section = document.querySelector('[data-honey-gift-card-section]');
  if (!section) return;
  const form = section.querySelector('.honey-gift-card__form');
  if (!form) return;

  const variantInput = form.querySelector('[data-gift-card-variant-id]');
  const occasionProperty = form.querySelector('[data-gift-card-occasion]');
  const designProperty = form.querySelector('[data-gift-card-design]');
  const amountProperty = form.querySelector('[data-gift-card-amount]');
  const status = form.querySelector('[data-gift-card-status]');
  const designHint = form.querySelector('[data-design-hint]');
  const categoryInputs = [...form.querySelectorAll('[data-category-choice]')];
  const designInputs = [...form.querySelectorAll('[name="gift-card-design-choice"]')];
  const designGroups = [...form.querySelectorAll('[data-design-group]')];
  const amountInputs = [...form.querySelectorAll('[data-fixed-amount]')];
  const copy = {
    designsAvailable: section.dataset.giftDesignAvailableLabel,
    noDesigns: section.dataset.giftNoDesignsLabel,
    variantMissing: section.dataset.giftVariantMissingLabel,
    recipientPlaceholder: section.dataset.giftRecipientPlaceholder,
  };

  const sortByAdminOrder = (container, selector) => {
    [...container.querySelectorAll(selector)]
      .sort((a, b) => Number(a.dataset.sortOrder || 999) - Number(b.dataset.sortOrder || 999))
      .forEach((node) => container.appendChild(node));
  };
  sortByAdminOrder(form.querySelector('.honey-gift-card__categories'), '[data-occasion-option]');
  sortByAdminOrder(form.querySelector('.honey-gift-card__designs'), '[data-design-group]');

  const selectDesign = (input) => {
    if (!input) return;
    input.checked = true;
    designProperty.value = input.dataset.designName || '';
  };

  const applyOccasion = () => {
    const occasion = form.querySelector('[data-category-choice]:checked');
    const handle = occasion?.value || '';
    occasionProperty.value = occasion?.dataset.categoryName || '';
    let visible = [];
    designGroups.forEach((group) => {
      const show = group.dataset.designOccasion === handle;
      group.hidden = !show;
      if (show) visible.push(group.querySelector('input'));
    });
    const selected = visible.find((input) => input.checked) || visible[0];
    selectDesign(selected);
    if (designHint) designHint.textContent = visible.length ? `${visible.length} ${copy.designsAvailable}` : copy.noDesigns;
  };

  const selectAmount = (input) => {
    const variantId = input?.dataset.variantId || '';
    variantInput.value = variantId;
    variantInput.disabled = !variantId;
    amountProperty.value = `SAR ${input?.value || ''}`;
    status.textContent = variantId ? '' : copy.variantMissing;
  };

  categoryInputs.forEach((input) => input.addEventListener('change', applyOccasion));
  designInputs.forEach((input) => input.addEventListener('change', () => selectDesign(input)));
  amountInputs.forEach((input) => input.addEventListener('change', () => selectAmount(input)));

  const sendDate = form.querySelector('[data-send-date]');
  const datePicker = form.querySelector('[data-gift-date-picker]');
  if (sendDate && datePicker) {
    const trigger = datePicker.querySelector('[data-gift-date-trigger]');
    const display = datePicker.querySelector('[data-gift-date-display]');
    const calendar = datePicker.querySelector('[data-gift-date-calendar]');
    const monthLabel = datePicker.querySelector('[data-gift-date-month]');
    const days = datePicker.querySelector('[data-gift-date-days]');
    const previous = datePicker.querySelector('[data-gift-date-prev]');
    const next = datePicker.querySelector('[data-gift-date-next]');
    const pad = (value) => String(value).padStart(2, '0');
    const toISO = (date) => `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
    const fromISO = (value) => value ? new Date(`${value}T00:00:00`) : null;
    const format = (value) => {
      const date = fromISO(value);
      return date ? `${pad(date.getDate())}/${pad(date.getMonth() + 1)}/${date.getFullYear()}` : 'DD/MM/YYYY';
    };
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    sendDate.min = toISO(today);
    const minimum = fromISO(sendDate.min);
    let visibleMonth = new Date(minimum.getFullYear(), minimum.getMonth(), 1);

    const setValue = (value) => {
      sendDate.value = value;
      display.textContent = format(value);
      sendDate.dispatchEvent(new Event('input', { bubbles: true }));
      sendDate.dispatchEvent(new Event('change', { bubbles: true }));
    };
    const close = (restoreFocus = false) => {
      calendar.hidden = true;
      trigger.setAttribute('aria-expanded', 'false');
      if (restoreFocus) trigger.focus();
    };
    const render = () => {
      const year = visibleMonth.getFullYear();
      const month = visibleMonth.getMonth();
      const firstWeekday = (new Date(year, month, 1).getDay() + 6) % 7;
      const count = new Date(year, month + 1, 0).getDate();
      monthLabel.textContent = new Intl.DateTimeFormat('en-GB', { month: 'long', year: 'numeric' }).format(visibleMonth);
      previous.disabled = new Date(year, month, 1) <= new Date(minimum.getFullYear(), minimum.getMonth(), 1);
      days.replaceChildren();
      for (let index = 0; index < firstWeekday; index += 1) {
        const blank = document.createElement('span');
        blank.className = 'honey-gift-card__calendar-blank';
        blank.setAttribute('aria-hidden', 'true');
        days.append(blank);
      }
      for (let day = 1; day <= count; day += 1) {
        const date = new Date(year, month, day);
        const value = toISO(date);
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'honey-gift-card__calendar-day';
        button.dataset.giftDateValue = value;
        button.textContent = String(day);
        button.setAttribute('role', 'gridcell');
        button.setAttribute('aria-label', new Intl.DateTimeFormat('en-GB', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' }).format(date));
        button.setAttribute('aria-selected', String(value === sendDate.value));
        button.disabled = value < sendDate.min;
        days.append(button);
      }
    };
    const open = () => {
      const selected = fromISO(sendDate.value);
      visibleMonth = selected && selected >= minimum ? new Date(selected.getFullYear(), selected.getMonth(), 1) : new Date(minimum.getFullYear(), minimum.getMonth(), 1);
      render();
      calendar.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');
    };
    trigger.addEventListener('click', () => calendar.hidden ? open() : close());
    previous.addEventListener('click', () => { visibleMonth = new Date(visibleMonth.getFullYear(), visibleMonth.getMonth() - 1, 1); render(); });
    next.addEventListener('click', () => { visibleMonth = new Date(visibleMonth.getFullYear(), visibleMonth.getMonth() + 1, 1); render(); });
    days.addEventListener('click', (event) => {
      const button = event.target.closest('[data-gift-date-value]');
      if (!button || button.disabled) return;
      setValue(button.dataset.giftDateValue);
      close(true);
    });
    calendar.addEventListener('keydown', (event) => {
      const button = event.target.closest('[data-gift-date-value]');
      if (event.key === 'Escape') { event.preventDefault(); close(true); return; }
      if (!button) return;
      const shifts = { ArrowLeft: -1, ArrowRight: 1, ArrowUp: -7, ArrowDown: 7 };
      if (!(event.key in shifts)) return;
      event.preventDefault();
      const target = fromISO(button.dataset.giftDateValue);
      target.setDate(target.getDate() + shifts[event.key]);
      if (toISO(target) < sendDate.min) return;
      visibleMonth = new Date(target.getFullYear(), target.getMonth(), 1);
      render();
      days.querySelector(`[data-gift-date-value="${toISO(target)}"]`)?.focus();
    });
    document.addEventListener('pointerdown', (event) => { if (!datePicker.contains(event.target)) close(); });
    document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && !calendar.hidden) close(true); });
    display.textContent = format(sendDate.value);
  }

  applyOccasion();
  selectAmount(form.querySelector('[data-fixed-amount]:checked'));
})();
